import { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import AddIcon from "@mui/icons-material/Add";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";

const CreatePaymentLinkMenu = ({
    onCreatorClick,
    onVendorClick,
    styles,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCreator = () => {
        handleClose();
        onCreatorClick?.();
    };

    const handleVendor = () => {
        handleClose();
        onVendorClick?.();
    };

    return (
        <>
            <Tooltip title="Create Payment Link">
                <AddIcon
                    sx={{
                        ...styles?.icon,
                        ...styles?.addIcon,
                        marginRight: 0.5,
                    }}
                    onClick={handleOpen}
                />
            </Tooltip>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleCreator}>
                    <ListItemIcon>
                        <PersonIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Creator Payment Link" />
                </MenuItem>

                <MenuItem onClick={handleVendor}>
                    <ListItemIcon>
                        <BusinessIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Vendor Payment Link" />
                </MenuItem>
            </Menu>
        </>
    );
};

export default CreatePaymentLinkMenu;